<template>
  <div>
    <div class="mainContent">
      <div class="mainContent_banner">{{ title }}</div>
        <div class="mainContent_banner_conent">{{ textData }}</div>
        <div class="morenotice">
          <router-link :to="'officialNews'">更多公告<span> ></span></router-link>
        </div>
    </div>
    <!-- <div class="policyAnnouncement policyAnnouncementfirst">
      扫码政策：所有渠道统一政策，起步50%扫码分成，月流水达到一万（享受60%扫码分成），月流水达到五万（享受70%扫码分成）
    </div>
    <div class="policyAnnouncement">包月政策：所有渠道无论等级，起步价5元一台(月)，最低10台</div> -->

    <div class="headerData">
      <div class="home_box">
        <!-- <div class="exhibitionData">
          <div class="singleData">
            <div class="todat_img">
              <img src="../assets/images-img/index_smday.png" />
            </div>
            <div class="today">
              <div class="today_price">{{ today }}元</div>
              <div class="today_data">今日扫码流水</div>
            </div>
          </div>

          <div class="singleData">
            <div class="todat_img">
              <img src="../assets/images-img/index_smzhou.png" />
            </div>
            <div class="today">
              <div class="today_price">{{ week }}元</div>
              <div class="today_data">本周扫码流水</div>
            </div>
          </div>

          <div class="singleData">
            <div class="todat_img">
              <img src="../assets/images-img/index_smmonth.png" />
            </div>
            <div class="today">
              <div class="today_price">{{ month }}元</div>
              <div class="today_data">当月扫码流水</div>
            </div>
          </div>

          <div class="singleData">
            <div class="todat_img">
              <img src="../assets/images-img/index_small.png" />
            </div>
            <div class="today">
              <div class="today_price">{{ sum }}元</div>
              <div class="today_data">扫码总流水</div>
            </div>
          </div>
        </div> -->
        <div class="header_left" style="margin-bottom: 20px">
          <el-form
            :inline="true"
            :model="lineForm"
            label-width="auto"
            class="el-from"
          >
            <el-form-item
              style="position: absolute; right: 50px; top: -10px; z-index: 99"
              label="日期"
            >
              <div class="block" style="color: #999999">
                <el-date-picker
                  v-model="value"
                  type="month"
                  @change="lineTimePick"
                  value-format="yyyy-MM"
                  placeholder="选择月"
                ></el-date-picker>
              </div>

              <!-- <div class="block">
            <span class="demonstration">月</span>
            <el-date-picker
              v-model="lineForm.date"
              type="month"
              @change="lineTimePick"
              format="yyyy"
              value-format="yyyy"
              placeholder="选择月"
            ></el-date-picker>
          </div> -->
            </el-form-item>
          </el-form>
          <div id="lineChart"></div>
        </div>
      </div>
    </div>

    <!-- <div class="headerData">
      <div class="home_box">
        <div class="header_p">包月流水概况</div>
        <div class="lineDivision"></div>
        <div class="exhibitionData">
          <div class="singleData">
            <div class="today">
              <span class="today_data">今日充值数据</span>
              <div class="today_price">{{ initListData.today }}元</div>
            </div>
            <div class="todat_img">
              <img src="../assets/images-img/today-data.png" />
            </div>
          </div>
          <div class="singleData">
            <div class="today">
              <span class="today_data">本周充值数据</span>
              <div class="today_price">{{ initListData.week }}元</div>
            </div>
            <div class="todat_img">
              <img src="../assets/images-img/week.png" />
            </div>
          </div>

          <div class="singleData">
            <div class="today">
              <span class="today_data">本月充值数据</span>
              <div class="today_price">{{ initListData.month }}元</div>
            </div>
            <div class="todat_img">
              <img src="../assets/images-img/month.png" />
            </div>
          </div>

          <div class="singleData">
            <div class="today">
              <span class="today_data">充值总数据</span>
              <div class="today_price">{{ initListData.sum }}元</div>
            </div>
            <div class="todat_img">
              <img src="../assets/images-img/total.png" />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="statistics">扫码流水概况</div>
    <div class="header_left" style="margin-bottom: 20px">
      <el-form
        :inline="true"
        :model="lineForm"
        label-width="auto"
        class="el-from"
      >
        <el-form-item label="日期">
          <div class="block">
            <el-date-picker
              v-model="value"
              type="month"
              @change="lineTimePick"
              value-format="yyyy-MM"
              placeholder="选择月"
            ></el-date-picker>
          </div> -->

    <!-- <div class="block">
            <span class="demonstration">月</span>
            <el-date-picker
              v-model="lineForm.date"
              type="month"
              @change="lineTimePick"
              format="yyyy"
              value-format="yyyy"
              placeholder="选择月"
            ></el-date-picker>
          </div> -->
    <!-- </el-form-item>
      </el-form>
      <div id="lineChart"></div>
    </div> -->

    <!-- v-if="limit" -->
    <!-- <template v-model="form" v-if="limit">
      <p class="header_p">渠道客户端下载</p>
      <p class="title_head">zip包</p>
      <div class="thing">
        <a v-bind:href="file_url_2" class="download_a" style="display:block" ref="down">下载扫码版客户端</a>
        <a v-bind:href="file_url_1" class="download_a" style="display:block">下载包月版客户端</a>
      </div>
      <p class="title_head">静默安装包</p>
      <div class="thing2">
        <div class="alldown">
          <a v-bind:href="file_url_3" class="download_a" style="display:block">下载包月静默安装包</a>
          <div
            class="download_a"
            style="display:block;line-height:40px"
            v-if="file_url_3 !=='' "
          >包月静默安装包：{{file_url_3}}</div>
        </div>
        <div class="alldown">
          <a v-bind:href="file_url_4" class="download_a" style="display:block">下载扫码静默安装包</a>
          <div
            class="download_a"
            style="display:block;line-height:40px"
            v-if="file_url_4 !=='' "
          >扫码静默安装包：{{file_url_4}}</div>
        </div>
      </div>
    </template>-->
  </div>
</template>
<script>
import * as sysApi from "../common/sys";

export default {
  data() {
    return {
      value: "",
      month: "",
      sum: "",
      today: "",
      week: "",
      form: {
        date: "",
        agentAmount: "",
        agentBalance: "",
        historyAgentAmount: "",
        historyAgentBalance: "",
        historyQrcodeAmount: "",
        historyQrcodeBalance: "",
        qrcodeAmount: "",
        qrcodeBalance: "",
      },
      lineForm: {
        date: "",
      },

      bingtu: {
        title: {
          text: "单月分成数据",
          subtext: "",
          x: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: ["订单"],
          // data: ["包月", "扫码"],
        },
        series: [
          {
            // name: "分成数据",
            type: "pie",
            //roseType:'area',
            radius: ["55%", "65%"],
            center: ["50%", "50%"],
            data: [],
            label: {
              normal: {
                show: true,
                //position:'inner',
                fontSize: 20,
                formatter: (parmas) => {
                  return parmas.data.name + parmas.data.value + "元";
                },
              },
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      option: {
        title: {
          text: "订单流水情况",
          textAlign: "left",
          padding: [0, 0, 0, 30],
          textStyle: {
            color: "#333",
            fontWeight: "bold",
            fontSize: 18,
          },
        },
        grid: {
          top: 90,
          right: 40,
          bottom: 30,
          left: 88,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#2D81FF",
              type: "dashed",
            },
          },
          backgroundColor: "rgba(255,255,255,1)",
          padding: [5, 10],
          textStyle: {
            color: "#5dfe97",
          },
          // formatter(params) {
          //   console.log(params);
          //   var res = '';
          //   for(var i=0;i<params.length;i++){
          //     if(i%2 == 0) {
          //       console.log(11);
          //         res = res +'<p>'+params[i].seriesName+':'+params[i].value+'</p>'
          //     } else {
          //        res= res+'<p>'+params[i].seriesName+':'+(parseInt(params[i].value)+parseInt(params[i-1].value))+'</p>';
          //    }
          //    return res
          //   }
          // },
        },
        legend: {
          icon: "circle",
          itemGap: 100,
          right: "50%",
          data: ["扫码流水", "订单流水"],
          align: "left",
          textStyle: {
            color: "#7D8CA3",
            fontSize: 16,
          },
        },
        xAxis: {
          type: "category",
          data: [],
          boundaryGap: false,
          splitLine: {
            show: true,
            interval: 2,
            lineStyle: {
              color: ["#eee"],
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#eee",
            },
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 16,
              color: "#999",
            },
            formatter: function(value, index) {
              var date = new Date(value);

              var texts = [date.getMonth() + 1, date.getDate()];
              return texts.join("-");
            },
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              color: ["#eee"],
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#EEEEEE",
            },
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 16,
              color: "#999",
            },
          },
        },
        series: [
          {
            name: "扫码流水",
            type: "line",
            smooth: true,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data: [],
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(44,130,255,0.2)",
                    },
                    {
                      offset: 1,
                      color: "rgba(44,130,255,0)",
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: "#1775FD",
              },
            },
            lineStyle: {
              normal: {
                width: 2,
              },
            },
          },
          {
            name: "订单流水",
            type: "line",
            smooth: true,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data: [],
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(85,205,199,0.2)",
                    },
                    {
                      offset: 1,
                      color: "rgba(85,205,199,0)",
                    },
                  ],
                  false
                ),
              },
            },
            itemStyle: {
              normal: {
                color: "#55CDC7",
              },
            },
            lineStyle: {
              normal: {
                width: 2,
                color: "#55CDC7",
              },
            },
          },
        ],
      },
      historyData: [],
      limit: false,
      file_url_2: "",
      file_url_1: "",
      file_url_3: "",
      file_url_4: "",
      textData: "",
      title: "",
      parme: {
        params: {
          page: "1",
          type: 2,
          page_size: "1",
        },
      },
      initListData: {
        month: "",
        sum: "",
        today: "",
        week: "",
      },
    };
  },
  created() {
    //this.divideIntoData();
    //this.monthinitQuery();
    this.initQuery();
  },
  mounted() {
    this.value = this.getMonth();
    this.drawLine(this.getMonth());
    this.aggregateChart(this.getMonth());
  },
  methods: {
    monthinitQuery() {
      this.$http.get(this.$api.api.day_month_money).then((res) => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.initListData = res.data.result;
      });
    },
    initQuery() {
      sysApi
        .notice(this.parme)
        .then((res) => {
          console.log(res.result)
          // this.count = res.count;
          this.title = res.result[0].title;
          this.textData = res.result[0].context;
          if (this.textData.length > 280) {
            this.textData = this.textData.slice(0, 280) + ".....";
          }
        })
        .catch((err) => console.log("请求异常信息:" + err));
    },
    // 渲染列表  扫码数据统计  接口
    // divideIntoData() {
    //   sysApi
    //     .sm_day_month_money()
    //     .then((res) => {
    //       this.month = res.result.month;
    //       this.sum = res.result.sum;
    //       this.today = res.result.today;
    //       this.week = res.result.week;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    lineTimePick(val) {
      console.log(val);
      this.drawLine(val);
      //this.aggregateChart(val);
    },
    drawLine(val) {
      let myChart = this.$echarts.init(document.getElementById("lineChart"));
      let type = "undefined" == typeof val ? "" : val;
      let params = "year=" + type;
      sysApi
        .sm_fc_self_scan(params)
        .then((res) => {
          this.option.xAxis.data = [];
          this.option.series[0].data = [];
          res.result.forEach((item, index) => {
            this.option.xAxis.data.push(item.date);
            this.option.series[0].data.push(item.amount); //扫码分成
          });
          myChart.setOption(this.option);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //包月数据
    aggregateChart(val) {
      let myChart = this.$echarts.init(document.getElementById("lineChart"));
      let type = "undefined" == typeof val ? "" : val;
      let params = "year=" + type;
      sysApi
        .sm_fc_self_month(params)
        .then((res) => {
          this.option.xAxis.data = [];
          this.option.series[1].data = [];
          res.result.forEach((item, index) => {
            this.option.xAxis.data.push(item.date);
            this.option.series[1].data.push(item.amount); //扫码分成
          });
          myChart.setOption(this.option);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let mydate = year.toString();
      let months = month.toString();
      let data = mydate + "-" + months;

      return data;
    },
  },
};
</script>
<style lang="scss" scope>
.mainContent {
  position: relative;
  background: #6692ff;
  background-size: 100% 100%;
  width: 100%;
  height: 124px;
  // display: flex;
  // justify-content: space-between;
  align-items: center;
  color: #fff;
  padding: 0 20px 0 34px;
  .mainContent_banner {
    font-size: 18px;
    font-weight: bold;
    // height: 44px;
    text-align: center;
    // background-color: #8dbaff;
    // border-radius: 22px;
    padding: 0 10px;
    line-height: 38px;
    margin-right: 42px;
  }
  .mainContent_banner_conent {
    font-size: 16px;
    line-height: 26px;
    // margin-right: 100px;
    // height: 48px;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // overflow: hidden;
  }
  .morenotice {
    position: absolute;
    right: 0;
    bottom: 10px;
    right: 0;
    margin-left: auto;
    line-height: 20px;
    font-size: 16px;
    margin-right: 25px;
    span {
      display: inline-block;
      width: 18px;
      height: 18px;
      background-color: #fff;
      border-radius: 9px;
      color: #2d81ff;
      text-align: center;
      font-family: "SimSun" !important;
      font-weight: 600;
      margin-left: 10px;
      font-size: 12px;
    }
  }
  .morenotice a:hover {
    cursor: pointer;
  }
}
.content-wrapper .content {
  padding: 0 !important;
}
.headerData {
  .home_box {
    padding: 30px 0 30px;
    .header_p {
      font-size: 18px;
      font-weight: bold;
      color: #2f2f2f;
      padding: 10px 0 0 10px;
    }
    .lineDivision {
      border-bottom: 1px solid #e8ecf1;
      margin: 20px 10px 30px 10px;
    }
    .exhibitionData {
      display: flex;
      justify-content: space-between;
      .singleData:last-child {
        border-right: 0;
      }
      .singleData {
        width: 364px;
        height: 142px;
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
        padding: 30px 24px 30px 24px;
        background-color: #fff;
        .today {
          .today_data {
            font-size: 16px;
            color: #7d8ca3;
          }
          .today_price {
            color: #293b55;
            font-size: 32px;
            font-weight: bold;
          }
        }
        .todat_img {
          width: 82px;
          height: 77px;
          margin-right: 30px;
          margin-top: 5px;
          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }
  }
}
.statistics {
  font-size: 18px;
  font-weight: bold;
  color: #2f2f2f;
  padding: 10px 0 0 10px;
}
.el-from {
  margin-top: 20px;
  opacity: 1;
  margin-left: 20px;
  position: relative;
  .time_data {
    position: absolute;
    top: 0;
    right: 0;
  }
}
#lineChart {
  width: 100%;
  height: 350px;
}
.el-scrollbar__wrap {
  // overflow: hidden !important;
  height: 100% !important;
}
.download_a {
  float: left;
}

.all_price {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  padding-left: 20px;
}

.all_price span {
  font-size: 22px;
  font-weight: bold;
  color: #000;
}

.headerData,
.alldown {
  overflow: hidden;
}

.header_left,
.header_right {
  // float: left;

  background: #fff;
  // height: 380px;
}
.header_left {
  margin-top: 30px;
  padding: 30px 0;
}
.info-title {
  padding: 10px 15px;
  font-size: 13px;
  font-weight: bold;
  background: #f0f0f0;
  border-bottom: 1px solid #b5cfd9;
}

#ul_firest {
  display: flex;
}

#ul_firest li {
  flex: 3;
}

.download_div {
  margin-top: 20px;
}

.title_head {
  margin: 10px auto;
  height: 40px;
  padding: 5px;
  line-height: 30px;
  font-size: 18px;
  color: #000000;
}

.thing,
.thing2 {
  overflow: hidden;
  padding-left: 50px;
}

.thing a {
  float: left;
  background: #409eff !important;
  color: #fff;
  width: 180px;
  text-align: center;
  border-radius: 0px;
  padding: 10px 20px;
  margin-right: 40px;
}

.thing2 a {
  // background: #409eff !important;
  // color: #fff;
  // width: 180px;
  // text-align: center;
  // margin-bottom: 10px;
  // border-radius: 0px;
  // padding: 10px 20px;
  // margin-right: 40px;
}

.thing .download_span {
  float: left;
  color: #000;
  border-radius: 0px;
  padding: 10px 20px;
  margin-right: 40px;
}

.thing > li {
  float: left;
  margin: 5px 10px;
  list-style: none;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  background: #fff;

  color: #666;
}

.thing > li > a {
  color: #666;
}

.thing > li > a > p {
  overflow: hidden;
}

.thing > li > a > p > span:nth-child(1) {
  float: left;
}

.thing > li > a > p > span:nth-child(2) {
  float: right;
  color: #ff0000;
}

.fun > li {
  float: left;
  list-style: none;
  margin-right: 15px;
}
.policyAnnouncement {
  color: #3167fc;
  padding-top: 10px;
  padding-left: 10px;
  font-size: 16px;
  border-bottom: 10px solid #f3f3f3;
  padding-bottom: 10px;
  font-weight: bold;
  // background: #3167FC;
}
.policyAnnouncementfirst {
  border-top: 10px solid #f3f3f3;
}
</style>
